import React, { useState } from "react";
import dayjs from "dayjs";
import OrderPage from "./OrderPage";
import BuyAgainModal from "./BuyAgainModal";
import { addItemToCart } from "api/Cart";
import { toast } from "react-toastify";

type TabKey = "ORDER_ID" | "PRODUCT" | "TIME";

const TAB_CONFIG: Record<TabKey, { label: string; width: number; left: number }> = {
    ORDER_ID: { label: "Mã đơn", width: 120, left: 0 },
    PRODUCT: { label: "Sản phẩm", width: 120, left: 120 },
    TIME: { label: "Ngày tháng", width: 140, left: 240 },
};

interface OrderDetailInfoProps {
    orderDetail: {
        id: number;
        customer_id: number;
        code: string;
        total: number;
        fullname: string;
        phone: string;
        address: string;
        created_at?: string;
        status?: number;
        history: {
            id: number;
            order_id: number;
            created_by: number;
            status: string;
            note: string;
            created_at: string;
            updated_at: string;
        }[];
        order_product: {
            id: number;
            order_id: number;
            discount_price: number | null;
            status: number | null;
            quantity_product: number;
            name_product: string;
            slug_product: string;
            avatar_product: string;
            price_product: number;
            product_id?: number;
            point_product?: number;
        }[];
    };
}

export default function MyOrderDetailInfo({ orderDetail }: OrderDetailInfoProps) {
    const [activeTab, setActiveTab] = useState<TabKey>("ORDER_ID");
    const [openBuyAgain, setOpenBuyAgain] = useState(false);
    const orderHistory = Array.isArray(orderDetail?.history) ? orderDetail.history : [];
    const latestHistory = orderHistory.length > 0 ? orderHistory[orderHistory.length - 1] : null;
    const latestStatus = latestHistory?.status;

    async function handleBuyAgain() {
        for (const product of orderDetail.order_product) {
            if (product.product_id) {
                await addItemToCart(product.product_id.toString(), product.quantity_product, false);
            }
        }
        setOpenBuyAgain(false);
        toast.success(`${orderDetail.order_product.length} sản phẩm đã được thêm vào giỏ hàng.`, {
            position: "bottom-right",
        });
        //window.location.href = "/cart";
    }

    return (
        <div className="MuiGrid-root MuiGrid-container MuiGrid-direction-xs-column">
            <div className="MuiGrid-root MuiGrid-container MuiGrid-spacing-xs-1">
                <div className="MuiGrid-root MuiGrid-item MuiGrid-grid-sm-12 MuiGrid-grid-md-7">
                    <div className="MuiPaper-root styles_wrapLeftOrder__UQE3U MuiPaper-outlined MuiPaper-rounded">
                        <div className="MuiBox-root css-1i43dhb">
                            <div className="MuiGrid-root MuiGrid-container MuiGrid-wrap-xs-nowrap MuiGrid-justify-content-xs-space-between">
                                <div className="MuiGrid-root" style={{ flex: "1 1 0%" }}>
                                    <p className="MuiTypography-root styles_orderID__XPkYT MuiTypography-body1">Đơn hàng #{orderDetail.code}</p>
                                    <div
                                        className="MuiGrid-root MuiGrid-container MuiGrid-item MuiGrid-grid-xs-12"
                                        style={{ marginTop: "8px" }}
                                    >
                                        <div className="MuiGrid-root MuiGrid-container MuiGrid-align-items-xs-center">
                                            <div
                                                className="styles_statusDot__xDP_b MuiBox-root css-0"
                                                style={{ backgroundColor: "rgb(162, 160, 160)" }}>
                                            </div>
                                            <p className="MuiTypography-root styles_statusTitle__dFL4s MuiTypography-body1">
                                                {(() => {
                                                    const status = latestStatus;
                                                    switch (status) {
                                                        case "0":
                                                            return "Đã hủy";
                                                        case "1":
                                                            return "Chờ xác nhận";
                                                        case "2":
                                                            return "Đã xác nhận";
                                                        case "3":
                                                            return "Đang xử lý";
                                                        case "4":
                                                            return "Đang giao hàng";
                                                        case "5":
                                                            return "Hoàn tất";
                                                        default:
                                                            return "Không xác định";
                                                    }
                                                })()}
                                            </p>
                                        </div>
                                        <div className="MuiGrid-root styles_container_btn_action__jlihB MuiGrid-container MuiGrid-item MuiGrid-grid-xs-12">
                                            <button
                                                className="MuiButtonBase-root MuiButton-root MuiButton-text styles_btn_action_order__WBeJ6"
                                                type="button"
                                                onClick={() => setOpenBuyAgain(true)}
                                            >
                                                <span className="MuiButton-label">
                                                    <span className="MuiButton-startIcon MuiButton-iconSizeMedium">
                                                        <span style={{ boxSizing: "border-box", display: "inline-block", overflow: "hidden", width: "15px", height: "17px", background: "none", opacity: 1, border: "0px", margin: "0px", padding: "0px", position: "relative" }}>
                                                            <img
                                                                data-origin-url="https://cdn-web-next.thuocsi.vn/images/header-v2/Cartv2_icon.svg"
                                                                src="https://cdn-web-next.thuocsi.vn/images/header-v2/Cartv2_icon.svg"
                                                                decoding="async"
                                                                data-nimg="fixed"
                                                                style={{ position: "absolute", inset: "0px", boxSizing: "border-box", padding: "0px", border: "none", margin: "auto", display: "block", width: "0px", height: "0px", minWidth: "100%", maxWidth: "100%", minHeight: "100%", maxHeight: "100%" }}
                                                            />
                                                        </span>
                                                    </span>Mua lại
                                                </span>
                                                <span className="MuiTouchRipple-root"></span>
                                            </button>

                                            {/* Modal */}
                                            {openBuyAgain && (
                                                <BuyAgainModal
                                                    orderId={orderDetail.code}
                                                    productList={orderDetail.order_product}
                                                    onClose={() => setOpenBuyAgain(false)}
                                                    onConfirm={() => {
                                                        handleBuyAgain();
                                                    }}
                                                />
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="MuiGrid-root MuiGrid-container MuiGrid-align-items-xs-center">
                                <div className="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12">
                                    <p className="MuiTypography-root styles_text_title__r2qdy MuiTypography-body1">
                                        Địa chỉ và thông tin người nhận hàng
                                    </p>
                                </div>

                                <ul
                                    style={{
                                        paddingLeft: "20px",
                                        marginBottom: "4px",
                                        color: "rgb(162, 160, 160)",
                                    }}
                                >
                                    <li>
                                        <div className="styles_contentDetail__Dpngm MuiBox-root css-0">
                                            <span style={{ marginRight: "12px" }}>Tên người nhận:</span>
                                            <span className="styles_contentValueInfo__dXcNZ">
                                                {orderDetail.fullname}
                                            </span>
                                        </div>
                                    </li>

                                    <li>
                                        <div className="styles_contentDetail__Dpngm MuiBox-root css-0">
                                            <span style={{ marginRight: "12px" }}>Địa chỉ giao hàng:</span>
                                            <span className="styles_contentValueInfo__dXcNZ">
                                                {orderDetail.address}
                                            </span>
                                        </div>
                                    </li>

                                    <li>
                                        <div className="styles_contentDetail__Dpngm MuiBox-root css-0">
                                            <span style={{ marginRight: "12px" }}>Số điện thoại:</span>
                                            <span className="styles_contentValueInfo__dXcNZ">
                                                {orderDetail.phone}
                                            </span>
                                        </div>
                                    </li>

                                    <li>
                                        <div className="styles_contentDetail__Dpngm MuiBox-root css-0">
                                            <span style={{ marginRight: "12px" }}>Email:</span>
                                            <span className="styles_contentValueInfo__dXcNZ">(Chưa có)</span>
                                        </div>
                                    </li>
                                </ul>

                                {/* <div
                                    className="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12"
                                    style={{ marginTop: "12px" }}
                                >
                                    <p className="MuiTypography-root styles_text_title__r2qdy MuiTypography-body1">
                                        Hình thức thanh toán &amp; Vận chuyển
                                    </p>
                                </div>

                                <ul
                                    style={{
                                        paddingLeft: "20px",
                                        marginBottom: "4px",
                                        color: "rgb(162, 160, 160)",
                                    }}
                                >
                                    <li>
                                        <div className="styles_contentDetail__Dpngm MuiBox-root css-0">
                                            <span style={{ marginRight: "12px" }}>
                                                Hình thức thanh toán:
                                            </span>
                                            <span className="styles_contentValueInfo__dXcNZ">
                                                Thanh toán chuyển khoản
                                            </span>
                                        </div>
                                    </li>

                                    <li>
                                        <div className="styles_contentDetail__Dpngm MuiBox-root css-0">
                                            <span style={{ marginRight: "12px" }}>Ngày giao:</span>
                                            <span className="styles_contentValueInfo__dXcNZ">
                                                Dự kiến Thứ bảy (24/01/2026)
                                            </span>
                                        </div>
                                    </li>

                                    <li>
                                        <div className="styles_contentDetail__Dpngm MuiBox-root css-0">
                                            <span style={{ marginRight: "12px" }}>
                                                Hình thức vận chuyển:
                                            </span>
                                            <span className="styles_contentValueInfo__dXcNZ">
                                                Giao hàng tiêu chuẩn
                                            </span>
                                        </div>
                                    </li>

                                    <li>
                                        <div className="styles_contentDetail__Dpngm MuiBox-root css-0">
                                            <span style={{ marginRight: "12px" }}>đơn vị vận chuyển:</span>
                                            <span className="styles_contentValueInfo__dXcNZ">(Chưa có)</span>
                                        </div>
                                    </li>

                                    <li>
                                        <div className="styles_contentDetail__Dpngm MuiBox-root css-0">
                                            <span style={{ marginRight: "12px" }}>Mã vận đơn:</span>
                                            <span className="styles_contentValueInfo__dXcNZ">(Chưa có)</span>
                                        </div>
                                    </li>

                                    <li>
                                        <div className="styles_contentDetail__Dpngm MuiBox-root css-0">
                                            <span style={{ marginRight: "12px" }}>Ghi chú:</span>
                                            <span className="styles_contentValueInfo__dXcNZ">
                                                Đơn hàng bị hủy do quá hạn chuyển khoản trong vòng 2880 phút
                                            </span>
                                        </div>
                                    </li> 
                                </ul>
                                */}
                            </div>
                        </div>
                    </div>
                </div>

                {/* right side */}
                <div className="MuiGrid-root MuiGrid-item MuiGrid-grid-sm-12 MuiGrid-grid-md-5">
                    <div className="MuiPaper-root styles_wrapRightOrder__Hzajm MuiPaper-outlined MuiPaper-rounded">
                        <div className="MuiGrid-root MuiGrid-container MuiGrid-align-items-xs-center MuiGrid-justify-content-xs-center">

                            <div className="MuiGrid-root styles_contentDetail__Dpngm MuiGrid-item MuiGrid-grid-xs-6 MuiGrid-grid-sm-3">
                                Ngày mua
                            </div>
                            <div className="MuiGrid-root styles_contentValue__UMLNg MuiGrid-item MuiGrid-grid-xs-6 MuiGrid-grid-sm-9">
                                15:21:44 Thứ Sáu (23/01/2026)
                            </div>

                            <div className="MuiGrid-root styles_contentDetail__Dpngm MuiGrid-item MuiGrid-grid-xs-6 MuiGrid-grid-sm-3">
                                Ngày giao
                            </div>
                            <div className="MuiGrid-root styles_contentValue__UMLNg MuiGrid-item MuiGrid-grid-xs-6 MuiGrid-grid-sm-9">
                                dự kiến giao ngày Thứ bảy (24/01/2026)
                            </div>

                            <div
                                className="MuiGrid-root MuiGrid-container MuiGrid-item MuiGrid-grid-xs-12"
                                style={{ marginTop: "10px" }}
                            >
                                <div
                                    className="MuiPaper-root MuiStepper-root MuiStepper-vertical MuiPaper-elevation0"
                                    style={{ padding: "0px" }}
                                >
                                    {orderHistory.map((historyItem, index) => (
                                        <React.Fragment key={historyItem.id}>
                                            <DetailOrderStatus key={historyItem.id} caseNumber={Number(historyItem.status)} date={dayjs(historyItem.created_at).format("HH:mm:ss - DD/MM/YYYY")} note={historyItem.note} />
                                            {index < orderHistory.length - 1 && (
                                                <div className="MuiStepConnector-root MuiStepConnector-vertical MuiStepConnector-active jss155">
                                                    <span className="MuiStepConnector-line jss157 MuiStepConnector-lineVertical" />
                                                </div>
                                            )}
                                        </React.Fragment>
                                    ))}

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}


interface DetailOrderStatusProps {
    caseNumber: number;
    date: string;
    note: string;
}

const DetailOrderStatus = ({ caseNumber, date, note }: DetailOrderStatusProps) => {
    switch (caseNumber) {
        case 0:
            return (
                <div
                    className="MuiStep-root MuiStep-vertical"
                    style={{ minHeight: "40px" }}
                >
                    <span className="MuiStepLabel-root MuiStepLabel-vertical styles_label__m9D2M">
                        <span className="MuiStepLabel-iconContainer">
                            <div className="styles_connector__hyA7j styles_exitStep__8qp6I">
                                <span
                                    style={{
                                        boxSizing: "border-box",
                                        display: "inline-block",
                                        overflow: "hidden",
                                        width: "initial",
                                        height: "initial",
                                        background: "none",
                                        opacity: 1,
                                        border: "0px",
                                        margin: 0,
                                        padding: 0,
                                        position: "relative",
                                        maxWidth: "100%",
                                    }}
                                >
                                    <span
                                        style={{
                                            boxSizing: "border-box",
                                            display: "block",
                                            width: "initial",
                                            height: "initial",
                                            background: "none",
                                            opacity: 1,
                                            border: "0px",
                                            margin: 0,
                                            padding: 0,
                                            maxWidth: "100%",
                                        }}
                                    >
                                        <img
                                            alt=""
                                            aria-hidden="true"
                                            src="data:image/svg+xml,%3csvg%20xmlns=%27http://www.w3.org/2000/svg%27%20version=%271.1%27%20width=%2720%27%20height=%2720%27/%3e"
                                            style={{
                                                display: "block",
                                                maxWidth: "100%",
                                                width: "initial",
                                                height: "initial",
                                                background: "none",
                                                opacity: 1,
                                                border: "0px",
                                                margin: 0,
                                                padding: 0,
                                            }}
                                        />
                                    </span>

                                    <img
                                        data-origin-url="https://cdn-web-next.thuocsi.vn/images/detailOrderV2/exit.svg"
                                        src="https://cdn-web-next.thuocsi.vn/images/detailOrderV2/exit.svg"
                                        decoding="async"
                                        data-nimg="intrinsic"
                                        style={{
                                            position: "absolute",
                                            inset: "0px",
                                            boxSizing: "border-box",
                                            padding: 0,
                                            border: "none",
                                            margin: "auto",
                                            display: "block",
                                            width: 0,
                                            height: 0,
                                            minWidth: "100%",
                                            maxWidth: "100%",
                                            minHeight: "100%",
                                            maxHeight: "100%",
                                        }}
                                    />
                                    <noscript />
                                </span>
                            </div>
                        </span>

                        <span className="MuiStepLabel-labelContainer">
                            <span className="MuiTypography-root MuiStepLabel-label MuiStepLabel-active MuiTypography-body2 MuiTypography-displayBlock">
                                Đã hủy
                                <span className="MuiStepLabel-root MuiStepLabel-horizontal styles_timeLine__WaNt3">
                                    <span className="MuiStepLabel-labelContainer">
                                        <span className="MuiTypography-root MuiStepLabel-label MuiTypography-body2 MuiTypography-displayBlock">
                                            15:21:44 Ngày 25/01/2026
                                        </span>
                                    </span>
                                </span>
                            </span>
                        </span>
                    </span>

                    <div
                        className="MuiStepContent-root jss154 MuiStepContent-last"
                    >
                        <div className="MuiCollapse-root MuiStepContent-transition MuiCollapse-entered" style={{ minHeight: "0px" }}>
                            <div className="MuiCollapse-wrapper">
                                <div className="MuiCollapse-wrapperInner">
                                    <p className="MuiTypography-root styles_Timeline__IYtbm MuiTypography-body1" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            );
        case 1:
            return (
                <div
                    className="MuiStep-root MuiStep-vertical MuiStep-completed"
                    style={{ minHeight: "40px" }}
                >
                    <span className="MuiStepLabel-root MuiStepLabel-vertical styles_label__m9D2M">
                        <span className="MuiStepLabel-iconContainer">
                            <div className="styles_connector__hyA7j styles_completedStep__m0EPy">
                                <span
                                    style={{
                                        boxSizing: "border-box",
                                        display: "inline-block",
                                        overflow: "hidden",
                                        width: "initial",
                                        height: "initial",
                                        background: "none",
                                        opacity: 1,
                                        border: "0px",
                                        margin: 0,
                                        padding: 0,
                                        position: "relative",
                                        maxWidth: "100%",
                                    }}
                                >
                                    <span
                                        style={{
                                            boxSizing: "border-box",
                                            display: "block",
                                            width: "initial",
                                            height: "initial",
                                            background: "none",
                                            opacity: 1,
                                            border: "0px",
                                            margin: 0,
                                            padding: 0,
                                            maxWidth: "100%",
                                        }}
                                    >
                                        <img
                                            alt=""
                                            aria-hidden="true"
                                            src="data:image/svg+xml,%3csvg%20xmlns=%27http://www.w3.org/2000/svg%27%20version=%271.1%27%20width=%2720%27%20height=%2720%27/%3e"
                                            style={{
                                                display: "block",
                                                maxWidth: "100%",
                                                width: "initial",
                                                height: "initial",
                                                background: "none",
                                                opacity: 1,
                                                border: "0px",
                                                margin: 0,
                                                padding: 0,
                                            }}
                                        />
                                    </span>

                                    <img
                                        data-origin-url="https://cdn-web-next.thuocsi.vn/images/detailOrderV2/wait_to_confirm.svg"
                                        src="https://cdn-web-next.thuocsi.vn/images/detailOrderV2/wait_to_confirm.svg"
                                        decoding="async"
                                        data-nimg="intrinsic"
                                        style={{
                                            position: "absolute",
                                            inset: "0px",
                                            boxSizing: "border-box",
                                            padding: 0,
                                            border: "none",
                                            margin: "auto",
                                            display: "block",
                                            width: 0,
                                            height: 0,
                                            minWidth: "100%",
                                            maxWidth: "100%",
                                            minHeight: "100%",
                                            maxHeight: "100%",
                                        }}
                                    />
                                    <noscript />
                                </span>
                            </div>
                        </span>

                        <span className="MuiStepLabel-labelContainer">
                            <span className="MuiTypography-root MuiStepLabel-label MuiStepLabel-completed MuiTypography-body2 MuiTypography-displayBlock">
                                Chờ xác nhận
                                <span className="MuiStepLabel-root MuiStepLabel-horizontal styles_timeLine__WaNt3">
                                    <span className="MuiStepLabel-labelContainer">
                                        <span className="MuiTypography-root MuiStepLabel-label MuiTypography-body2 MuiTypography-displayBlock">
                                            {date}
                                        </span>
                                    </span>
                                </span>
                            </span>
                        </span>
                    </span>

                    <div className="MuiStepContent-root jss154" />
                </div>
            );
        case 2:
            return (
                <div
                    className="MuiStep-root MuiStep-vertical MuiStep-completed"
                    style={{ minHeight: "40px" }}
                >
                    <span className="MuiStepLabel-root MuiStepLabel-vertical styles_label__m9D2M">
                        <span className="MuiStepLabel-iconContainer">
                            <div className="styles_connector__hyA7j styles_completedStep__m0EPy">
                                <span
                                    style={{
                                        boxSizing: "border-box",
                                        display: "inline-block",
                                        overflow: "hidden",
                                        width: "initial",
                                        height: "initial",
                                        background: "none",
                                        opacity: 1,
                                        border: "0px",
                                        margin: 0,
                                        padding: 0,
                                        position: "relative",
                                        maxWidth: "100%",
                                    }}
                                >
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="20"
                                        height="20"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                    >
                                        <rect
                                            x="3"
                                            y="5"
                                            width="18"
                                            height="14"
                                            rx="2"
                                            stroke="#636363"
                                            stroke-width="2"
                                        />
                                        <path
                                            d="M7 12.5L10.5 16L17 9"
                                            stroke="#636363"
                                            stroke-width="2"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                        />
                                    </svg>
                                </span>
                            </div>
                        </span>

                        <span className="MuiStepLabel-labelContainer">
                            <span className="MuiTypography-root MuiStepLabel-label MuiStepLabel-completed MuiTypography-body2 MuiTypography-displayBlock">
                                Đã xác nhận
                                <span className="MuiStepLabel-root MuiStepLabel-horizontal styles_timeLine__WaNt3">
                                    <span className="MuiStepLabel-labelContainer">
                                        <span className="MuiTypography-root MuiStepLabel-label MuiTypography-body2 MuiTypography-displayBlock">
                                            {date}
                                        </span>
                                    </span>
                                </span>
                            </span>
                        </span>
                    </span>

                    <div className="MuiStepContent-root jss154" />
                </div>
            );
        case 3:
            return (
                <div
                    className="MuiStep-root MuiStep-vertical MuiStep-completed"
                    style={{ minHeight: "40px" }}
                >
                    <span className="MuiStepLabel-root MuiStepLabel-vertical styles_label__m9D2M">
                        <span className="MuiStepLabel-iconContainer">
                            <div className="styles_connector__hyA7j styles_completedStep__m0EPy">
                                <span
                                    style={{
                                        boxSizing: "border-box",
                                        display: "inline-block",
                                        overflow: "hidden",
                                        width: "initial",
                                        height: "initial",
                                        background: "none",
                                        opacity: 1,
                                        border: "0px",
                                        margin: 0,
                                        padding: 0,
                                        position: "relative",
                                        maxWidth: "100%",
                                    }}
                                >
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="20"
                                        height="20"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                    >
                                        <rect
                                            x="3"
                                            y="5"
                                            width="18"
                                            height="14"
                                            rx="2"
                                            stroke="#636363"
                                            stroke-width="2"
                                        />
                                        <path
                                            d="M12 9V11"
                                            stroke="#636363"
                                            stroke-width="2"
                                            stroke-linecap="round"
                                        />
                                        <path
                                            d="M12 13V15"
                                            stroke="#636363"
                                            stroke-width="2"
                                            stroke-linecap="round"
                                            opacity="0.4"
                                        />
                                    </svg>

                                </span>
                            </div>
                        </span>

                        <span className="MuiStepLabel-labelContainer">
                            <span className="MuiTypography-root MuiStepLabel-label MuiStepLabel-completed MuiTypography-body2 MuiTypography-displayBlock">
                                Đang xử lý
                                <span className="MuiStepLabel-root MuiStepLabel-horizontal styles_timeLine__WaNt3">
                                    <span className="MuiStepLabel-labelContainer">
                                        <span className="MuiTypography-root MuiStepLabel-label MuiTypography-body2 MuiTypography-displayBlock">
                                            {date}
                                        </span>
                                    </span>
                                </span>
                            </span>
                        </span>
                    </span>

                    <div className="MuiStepContent-root jss154" />
                </div>
            );
        case 4:
            return (
                <div
                    className="MuiStep-root MuiStep-vertical MuiStep-completed"
                    style={{ minHeight: "40px" }}
                >
                    <span className="MuiStepLabel-root MuiStepLabel-vertical styles_label__m9D2M">
                        <span className="MuiStepLabel-iconContainer">
                            <div className="styles_connector__hyA7j styles_completedStep__m0EPy">
                                <span
                                    style={{
                                        boxSizing: "border-box",
                                        display: "inline-block",
                                        overflow: "hidden",
                                        width: "initial",
                                        height: "initial",
                                        background: "none",
                                        opacity: 1,
                                        border: "0px",
                                        margin: 0,
                                        padding: 0,
                                        position: "relative",
                                        maxWidth: "100%",
                                    }}
                                >
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                    >
                                        <path
                                            d="M3 7H15V15H3V7Z"
                                            stroke="#636363"
                                            strokeWidth="2"
                                            strokeLinejoin="round"
                                        />
                                        <path
                                            d="M15 10H19L21 12V15H15V10Z"
                                            stroke="#636363"
                                            strokeWidth="2"
                                            strokeLinejoin="round"
                                        />
                                        <circle cx="7" cy="17" r="2" stroke="#636363" strokeWidth="2" />
                                        <circle cx="17" cy="17" r="2" stroke="#636363" strokeWidth="2" />
                                        <path
                                            d="M1 9H3M1 12H3M1 15H3"
                                            stroke="#636363"
                                            strokeWidth="2"
                                            strokeLinecap="round"
                                        />
                                    </svg>
                                </span>
                            </div>
                        </span>

                        <span className="MuiStepLabel-labelContainer">
                            <span className="MuiTypography-root MuiStepLabel-label MuiStepLabel-completed MuiTypography-body2 MuiTypography-displayBlock">
                                Đang giao hàng
                                <span className="MuiStepLabel-root MuiStepLabel-horizontal styles_timeLine__WaNt3">
                                    <span className="MuiStepLabel-labelContainer">
                                        <span className="MuiTypography-root MuiStepLabel-label MuiTypography-body2 MuiTypography-displayBlock">
                                            {date}
                                        </span>
                                    </span>
                                </span>
                            </span>
                        </span>
                    </span>

                    <div className="MuiStepContent-root jss154" />
                </div>
            );
        case 5:
            return (
                <div
                    className="MuiStep-root MuiStep-vertical MuiStep-completed"
                    style={{ minHeight: "40px" }}
                >
                    <span className="MuiStepLabel-root MuiStepLabel-vertical styles_label__m9D2M">
                        <span className="MuiStepLabel-iconContainer">
                            <div className="styles_connector__hyA7j styles_completedStep__m0EPy">
                                <span
                                    style={{
                                        boxSizing: "border-box",
                                        display: "inline-block",
                                        overflow: "hidden",
                                        width: "initial",
                                        height: "initial",
                                        background: "none",
                                        opacity: 1,
                                        border: "0px",
                                        margin: 0,
                                        padding: 0,
                                        position: "relative",
                                        maxWidth: "100%",
                                    }}
                                >
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="28"
                                        height="28"
                                        viewBox="0 0 28 28"
                                        fill="none"
                                    >
                                        <circle cx="14" cy="14" r="13" fill="#e7f9ef" />
                                        <circle
                                            cx="14"
                                            cy="14"
                                            r="13"
                                            stroke="#22c55e"
                                            stroke-width="2"
                                        />
                                        <path
                                            d="M9 14L12 17L19 10"
                                            stroke="#22c55e"
                                            stroke-width="2.2"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                        />
                                    </svg>
                                </span>
                            </div>
                        </span>

                        <span className="MuiStepLabel-labelContainer">
                            <span className="MuiTypography-root MuiStepLabel-label MuiStepLabel-completed MuiTypography-body2 MuiTypography-displayBlock">
                                Hoàn tất
                                <span className="MuiStepLabel-root MuiStepLabel-horizontal styles_timeLine__WaNt3">
                                    <span className="MuiStepLabel-labelContainer">
                                        <span className="MuiTypography-root MuiStepLabel-label MuiTypography-body2 MuiTypography-displayBlock">
                                            {date}
                                        </span>
                                    </span>
                                </span>
                            </span>
                        </span>
                    </span>

                    <div className="MuiStepContent-root jss154" />
                </div>
            );
        default:
            return <></>;
    }
}